import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { RelationUserFolderDb } from '../redux/relationUserFolderDbSlice';

const useOneRUFDbByFolder = (folderId: string | undefined): [string | undefined, RelationUserFolderDb | undefined] => {
  const relationUserFolderDb = useSelector((state: RootState) => state.relationUserFolderDb);
  const id = Object.keys(relationUserFolderDb.relationUserFolders).find(id => relationUserFolderDb.relationUserFolders[id].folderId === folderId);
  const value = id ? relationUserFolderDb.relationUserFolders[id] : undefined;

  return [id, value];
}

export default useOneRUFDbByFolder;
